import React from 'react';
import Modal from 'react-modal';
import Empty from '../Empty';
import PDFPreview from './PDFPreview';
import {errors as E} from '../../constants/errors';
import nothing from '../../assets/nothing.svg';
import styles from './styles.module.scss';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    padding: '2px',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    zIndex: 999
  }
};

const ImagePreview = ({url}) => (
  <div className={styles.imageContainer}>
    <img src={url} alt="content" className={styles.image}/>
  </div>
);

const FilePreview = ({
                       isOpen,
                       close,
                       dataURI,
                       type,
                     }) => {
  const getPreviewer = () => {
    switch (type) {
      case 'pdf':
        return <PDFPreview url={dataURI} editMode={false}/>;
      case 'image':
        return <ImagePreview url={dataURI}/>;
      default:
        return <Empty icon={nothing} message={E.SERVER_ERROR}/>;
    }
  };

  return Boolean(type)
    ? (
      <Modal
        isOpen={isOpen}
        style={customStyles}
        onRequestClose={close}
      >
        <div dir="rtl" className={styles.serverRequestModalContent}>
          {dataURI ? getPreviewer() : <div>2222</div>}
          <div className={styles.buttons}>
            <div className={styles.declineBtn} onClick={close}>
              סגירה
            </div>
          </div>
        </div>
      </Modal>
    )
    : null;
};

export default FilePreview;